module.exports = __webpack_public_path__ + "media/images/logo-dfc45aba83d6bdc29976593966785f4d.png";